import { createNameContext, usePersistedState } from '@showroomjs/ui';
import * as React from 'react';
import { audienceDefault } from './config';
const TargetAudienceContext = createNameContext('TargetAudienceContext', 'developer');
const TargetAudienceDispatch = createNameContext('AudienceDispatch', () => { });
export const TargetAudienceProvider = (props) => {
    const [audience, setAudience] = usePersistedState(audienceDefault && audienceDefault === 'design' ? 'designer' : 'developer', 'audience');
    return (React.createElement(TargetAudienceContext.Provider, { value: audience },
        React.createElement(TargetAudienceDispatch.Provider, { value: setAudience }, props.children)));
};
export const useTargetAudience = () => React.useContext(TargetAudienceContext);
export const useTargetAudienceDispatch = () => React.useContext(TargetAudienceDispatch);
//# sourceMappingURL=use-target-audience.js.map